module.exports = __webpack_public_path__ + "static/media/HKMAP.f602f1cd.jpg";